import MainRoutes from 'Routes';
import { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthorizedOutlet from 'feature/login/layout/AuthorizationOutlet';
import NewVersionBanner from 'feature/appUpdate/NewVersionBanner';

// Keep lazy pages suspending to this one root boundary: with transition
// navigations React then holds the current page until the next is ready. A
// per-route Suspense mounts fresh on each navigation and blanks the app.
function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true }}>
      <Suspense fallback={null}>
        <Routes>
          <Route element={<AuthorizedOutlet />}>
            {MainRoutes}
          </Route>
        </Routes>
      </Suspense>
      <NewVersionBanner />
    </BrowserRouter>
  );
};

export default App;
